import React from 'react';
import { useSingleEffect } from 'react-haiku';

import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Editor from 'components/Editor';
import Container from 'components/Misc/Container';
import { Title, Preamble } from 'components/Misc/Typography';

import { useArticleProfileStore } from 'store/article/useArticleProfileStore';

const Preview = ({ tab, setTab }) => {
	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use article's profile store
	const article = useArticleProfileStore(state => state.article);

	return (
		<Container className="mt-4 p-4 space-y-4">
			<Title
				title={article.title}
				subtitle={DayJs(article.createdAt).format('D. MMM, YYYY')}
				className="text-2xl font-bold tracking-wide"
			/>

			<Show if={article.thumbnail}>
				<img
					alt={article.thumbnail}
					src={`${process.env.REACT_APP_CDN}/articles/${article.slug}/${article.thumbnail}`}
					className="mx-auto max-w-full max-h-96 rounded-lg"
				/>
			</Show>

			<Show if={article.description}>
				<Preamble value={article.description} />
			</Show>

			<Editor
				readOnly
				path="articles"
				folder={article.slug}
				value={article.content}
			/>
		</Container>
	);
};

export default Preview;